import { ReportResponseTypes } from '@mode/shared/data-access-webapp';
import { ChartTypes, FormsResponse, SpaceResource } from '@mode/shared/contract-common';
import { ReportDomain } from '@mode/shared/contract-common';
import { Encoding } from '@mode-vegas/vegas';
import { createAction, props } from '@ngrx/store';
import { ReportResource } from 'libs/shared/data-access-webapp/src/lib/reports/report-response.types';

export const editorRouteLoadReport = createAction(
  '[Report Edit Route] Load Report',
  props<{ username: string; token: string }>()
);

export const reportViewRouteLoadReport = createAction(
  '[Report View Route] Load Report',
  props<{ username: string; token: string }>()
);

export const datasetViewRouteLoadReport = createAction(
  '[Dataset View Route] Load Report',
  props<{ username: string; token: string }>()
);

export const apiLoadReportSuccess = createAction('[Api] Load Report Success', props<{ report: ReportDomain.Report }>());
export const apiLoadReportFailure = createAction('[Api] Load Report Failure', props<{ error: any }>());

export const editorRouteLoadNewReport = createAction(
  '[Report Edit Route] Load New Report',
  props<{ report: ReportResponseTypes.ReportResource }>()
);
export const apiLoadNewReportSuccess = createAction(
  '[Api] Load New Report Success',
  props<{ report: ReportDomain.Report }>()
);
export const apiLoadNewReportFailure = createAction('[Api] Load New Report Failure', props<{ error: any }>());

export const editorDialogRenameReport = createAction(
  '[Report Edit Rename Dialog] Rename Report',
  props<{ token: string; name: string; description: string }>()
);

export const apiRenameReportSuccess = createAction(
  '[Api] Rename Report Success',
  props<{ report: ReportDomain.Report }>()
);

export const publishDatasetSuccess = createAction(
  '[Api] Publish Dataset Rename Success',
  props<{ name: string; publishedAt: string }>()
);

export const apiRenameReportFailure = createAction('[Api] Rename Report Failure', props<{ error: any }>());

export const createReportAndChartFromDatasetEditor = createAction(
  '[Dataset Edit Route] Create Report and Chart With Dataset',
  props<{
    accountId: string;
    switchViewToken: string;
    chartColorPaletteToken: string;
    encoding: Encoding;
    format: ChartTypes.ChartFormat;
    fieldFormats: ChartTypes.FieldFormatMap;
  }>()
);

export const createReportAndChartFromDatasetView = createAction(
  '[Dataset View Route] Create Report and Chart With Dataset',
  props<{
    accountId: string;
    switchViewToken: string;
    chartColorPaletteToken: string;
    encoding: Encoding;
    format: ChartTypes.ChartFormat;
    fieldFormats: ChartTypes.FieldFormatMap;
  }>()
);

export const createReportAndChartFromDatasetBrowserSearch = createAction(
  '[Dataset Browser Route] Create Report and Chart With Dataset from Search Tab',
  props<{
    accountId: string;
    switchViewToken: string;
    chartColorPaletteToken: string;
    encoding: Encoding;
    format: ChartTypes.ChartFormat;
    fieldFormats: ChartTypes.FieldFormatMap;
  }>()
);

export const createReportAndChartFromDatasetBrowserUrl = createAction(
  '[Dataset Browser Route] Create Report and Chart With Dataset from Url Tab',
  props<{
    accountId: string;
    switchViewToken: string;
    chartColorPaletteToken: string;
    encoding: Encoding;
    format: ChartTypes.ChartFormat;
    fieldFormats: ChartTypes.FieldFormatMap;
  }>()
);

export const loadWorkspaceHeaderData = createAction(
  '[Workspace Component] Load Header Report Data',
  props<{ token: string }>()
);

export const loadWorkspaceHeaderDataSuccess = createAction(
  '[Workspace Component] Load Header Report Data Success',
  props<{ headerReportData: ReportResource }>()
);

export const loadWorkspaceHeaderDataFailure = createAction(
  '[Workspace Component] Load Header Report Data Failure',
  props<{ error: any }>()
);

export const loadReportViewContainerHeaderData = createAction(
  '[Report View Container] Load Header Report Data',
  props<{ token: string }>()
);

export const loadReportViewContainerHeaderDataSuccess = createAction(
  '[Report View Container] Load Header Report Data Success',
  props<{ headerReportData: ReportResource }>()
);

export const loadReportViewContainerHeaderDataFailure = createAction(
  '[Report View Container] Load Header Report Data Failure',
  props<{ error: any }>()
);

export const updateHeaderReportDataManually = createAction(
  '[Move Space Modal] Update Header Report Data',
  props<{ headerReportData: ReportResource }>()
);

export const updateHeaderSpaceDataManually = createAction(
  '[Workspace Component] Update Header Space Data',
  props<{ space: SpaceResource }>()
);

export const updateHeaderReportSharedState = createAction(
  '[Move Space Modal] Update Header Report Shared State',
  props<{ shared: boolean; forms: FormsResponse }>()
);

export const loadDatasetWorkspaceHeaderData = createAction(
  '[Dataset Workspace Component] Load Header Report Data',
  props<{ token: string }>()
);

export const loadDatasetWorkspaceHeaderDataSuccess = createAction(
  '[Dataset Workspace Component] Load Header Report Data Success',
  props<{ headerReportData: ReportResource }>()
);

export const loadDatasetWorkspaceHeaderDataFailure = createAction(
  '[Dataset Workspace Component] Load Header Report Data Failure',
  props<{ error: any }>()
);

export const loadRestrictedReportViewContainerHeaderData = createAction(
  '[Report View Container] Load Restricted Header Report Data'
);

export const loadRestrictedReportViewContainerHeaderDataSuccess = createAction(
  '[Report View Container] Load Restricted Header Report Data Success',
  props<{ headerReportData: ReportResource }>()
);

export const loadRestrictedReportViewContainerHeaderDataFailure = createAction(
  '[Report View Container] Load Restricted Header Report Data Failure',
  props<{ error: any }>()
);

export const submitUseDatasetAnalytics = createAction(
  '[Dataset Browser Route] Submit Analytics For Use Dataset',
  props<{
    runMethodType: string;
    analyticEventName: string;
    location: string;
    actionType: string;
    context: string;
    context_id: string;
  }>()
);
